import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "flex items-center space-x-5" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "text-lg font-bold text-primary-text dark:text-primary-dark-text" }
const _hoisted_5 = { class: "text-sm text-secondary-text/70 dark:text-secondary-dark-text/70 mt-1.5" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickActionButton',
  props: {
    title: {},
    description: {},
    icon: {},
    color: {}
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props



const iconBgClass = computed(() => {
  const colors = {
    primary: 'from-primary to-primary-hover dark:from-primary-dark dark:to-primary-dark-hover',
    success: 'from-success to-success-hover dark:from-success-dark dark:to-success-dark-hover',
    danger: 'from-danger to-danger-hover dark:from-danger-dark dark:to-danger-dark-hover',
    warning: 'from-warning to-warning-hover dark:from-warning-dark dark:to-warning-dark-hover',
    info: 'from-info to-info-hover dark:from-info-dark dark:to-info-dark-hover'
  }
  return colors[props.color || 'primary']
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    class: "card w-full text-left transform hover:-translate-y-1 transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-primary/50 dark:focus:ring-primary-dark/50 group"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex-shrink-0 rounded-xl p-4 shadow-elegant-lg bg-gradient-to-br transition-transform duration-300 group-hover:scale-110", iconBgClass.value])
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), { class: "h-8 w-8 text-white" }))
        ], 2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.title), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.description), 1)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-shrink-0 transition-transform duration-300 group-hover:translate-x-1" }, [
          _createElementVNode("svg", {
            class: "h-5 w-5 text-primary/60 dark:text-primary-dark/60 group-hover:text-primary dark:group-hover:text-primary-dark",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
              "clip-rule": "evenodd"
            })
          ])
        ], -1))
      ])
    ])
  ]))
}
}

})